import axios from 'axios';

export default {
  getSubscriptions,
  updateSubscription,
  updateSubscriptionColor,
  cancelSubscription,
  updateShipAddressForSubscriptions,
  updatePaymentProfileForSubscriptions,
  getSubDateOptions,
  getSubPauseDates,
  getCancelReasons
};

export function getSubscriptions(params) {
  return axios.get('/api/subscription/getSubscriptionsByCustomerId', params);
}

export function updateSubscription(params) {
  return axios.post('/api/subscription/updateSubscription', params);
}

export function updateSubscriptionColor(params) {
  return axios.post('/api/subscription/updateSubscriptionColor', params);
}

export function cancelSubscription(params) {
  return axios.post('/api/subscription/cancelSubscription', params);
}

export function updateShipAddressForSubscriptions(params) {
  return axios.post('/api/subscription/updateShipAddressForSubscriptions', params);
}

export function updatePaymentProfileForSubscriptions(params) {
  return axios.post('/api/subscription/updatePaymentProfileForSubscriptions', params);
}

export function getSubDateOptions(params) {
  return axios.get('/api/subscription/getSubDateOptions', { params });
}

export function getSubPauseDates(params) {
  return axios.get('/api/subscription/getSubPauseDates', { params });
}

export function getCancelReasons(params) {
  return axios.get('/api/subscription/getCancelReasons', { params });
}
